import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import IntraGroup from "../../../Models/Catalogue/Generic/IntraGroup";
import { CatalogueEntry } from "../CatalogueEntry";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class IntraGroupCatalogueEntry extends CatalogueEntry<IntraGroup> {

    constructor() {
        super("Intra Groups", IntraGroup);
    }

    public get editRole() {
        return CatalogueRoles.IntraGroups.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.intraGroups;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveIntraGroups;
    }
    
    public renderRow(item: IntraGroup, meta: Model.TransformMetaType<IntraGroup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.intraGroupCode} />
                <NeoGrid.Column bind={meta.intraGroupName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}